import React from 'react'

import { CreateOperatorForm, CreateOperatorPageHeader } from '@/components/pages/Operator/Create'

import { useCreateOperator } from './Create.hooks'

const CreateOperator = () => {
  const { createOperator, loading } = useCreateOperator()

  return (
    <>
      <CreateOperatorPageHeader />
      <CreateOperatorForm {...{ loading }} onSubmit={createOperator} />
    </>
  )
}

CreateOperator.displayName = 'CreateOperator'
export default CreateOperator
